import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  IconButton,
  Tooltip
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHeaderContext } from '@/contexts/HeaderContext';
import { SelfIntakeInterface } from '@/components/NewTranscriptPageComponents/V4/SelfIntakeInterface';

const SelfIntakePage: React.FC = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const navigate = useNavigate();
  const { setHeaderText, setMenuActions } = useHeaderContext();

  useEffect(() => {
    setHeaderText('Self Intake');
    setMenuActions(
      <Tooltip title="Back to Transcript">
        <IconButton onClick={() => navigate(`/transcript/${sessionId}`)}>
          <ArrowBackIcon />
        </IconButton>
      </Tooltip>
    );
    return () => {
      setHeaderText('');
      setMenuActions(null);
    };
  }, [setHeaderText, setMenuActions, navigate, sessionId]);

  if (!sessionId) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">Missing session id.</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <SelfIntakeInterface sessionId={sessionId} />
    </Box>
  );
};

export default SelfIntakePage;
